<div class="rd-widget widget-{{widgetConfig?.widgetId}}" *ngIf="widgetData">
  <table class="widget-large cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" colspan="32" class="widget-grid-column widget-header-red" style="text-align: start;">
            <widget-value class="widget-header-red" [align]="'left'" [color]="'white'" [bold]="true">Lease Summary</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
    </thead>

    <tbody>
      <ng-container *ngFor="let row of rows; let i = index">
        <dynamic-growth-row [row]="i + 2" [widget]="this">
          <tr [ngClass]="{ 'lightGreyTableRow': isVisible(i) }">
            <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="row.label" [align]="'left'"></widget-label></td>
            <td colspan="2">&nbsp;</td>
            <td colspan="22">
              <widget-value [align]="'right'">
                <ng-container *ngIf="row.type === 'number'">{{ widgetData[row.data] | rdLocalizedNumber:0 }}</ng-container>
                <ng-container *ngIf="row.type === 'date'">{{ widgetData[row.data] | rdLocalizedDate }}</ng-container>
                <ng-container *ngIf="row.type !== 'number' && row.type !== 'date'">{{ widgetData[row.data] }}</ng-container>
                <ng-container *ngIf="row.additionalData == 'unitOfArea'">&nbsp;{{unitOfArea}}</ng-container>
                <ng-container *ngIf="row.additionalData == 'creditRatingSource'">&nbsp;{{widgetData.creditRatingSource}}</ng-container>
              </widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
      </ng-container>

      <dynamic-growth-row [row]="rows?.length + 3" [widget]="this">
        <tr style="height: 16px;">
          <td colspan="8"></td>
          <td colspan="2">&nbsp;</td>
          <td colspan="22"></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="rows?.length + 4" [widget]="this">
        <tr class="golden-line-widget-table">
          <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="'labelBaseRentAndEscalations'" [align]="'left'"></widget-label></td>
          <td colspan="2">&nbsp;</td>
          <td colspan="6" class="bold"><widget-label [widget]="this" [fieldName]="'labelPeriod'" [align]="'center'"></widget-label></td>
          <td colspan="4" class="bold"><widget-label [widget]="this" [fieldName]="'labelMonths'" [align]="'center'"></widget-label></td>
          <td colspan="4" class="bold"><widget-label [widget]="this" [fieldName]="'labelAnnualRent'" [align]="'center'"></widget-label></td>
          <td colspan="4" class="bold"><widget-label [widget]="this" [fieldName]="'labelChange'" [align]="'center'"></widget-label></td>
          <td colspan="4" class="bold"><widget-label [widget]="this" [fieldName]="'labelSfYear'" [align]="'center'"></widget-label></td>
        </tr>
      </dynamic-growth-row>

      <ng-container *ngFor="let row of widgetData.rows; let i = index;">
        <dynamic-growth-row [row]="rows?.length + 5 + i" [widget]="this">
          <tr>
            <td colspan="8"><widget-value [align]="'left'">{{row.baseRentAndEscalations }}</widget-value></td>
            <td colspan="2">&nbsp;</td>
            <td colspan="6"><widget-value [align]="'center'">{{row.periodFrom | rdLocalizedDate}} - {{row.periodTo | rdLocalizedDate}}</widget-value></td>
            <td colspan="4"><widget-value [align]="'center'">{{row.months }}</widget-value></td>
            <td colspan="4"><widget-value [align]="'center'">{{row.annualRent | rdLocalizedNumber:0 }}{{currency}}</widget-value></td>
            <td colspan="4"><widget-value [align]="'center'">{{row.percentChange * 100 | rdLocalizedNumber:2 }} %</widget-value></td>
            <td colspan="4"><widget-value [align]="'center'">{{row.termRentPerAreaAndYear| rdLocalizedNumber:2 }}{{currency}}</widget-value></td>
          </tr>
        </dynamic-growth-row>
      </ng-container>
      <dynamic-growth-row [row]="widgetData.rows?.length + rows?.length + 6" [widget]="this">
        <tr>
          <td colspan="16" class="bold"><widget-label [widget]="this" [fieldName]="'labelCurrentRent'" [align]="'right'"></widget-label></td>
          <td colspan="16"><widget-value [align]="'left'">{{widgetData.currentRent }}</widget-value></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData.rows?.length + rows?.length + 7" [widget]="this">
        <tr>
          <td colspan="16" class="bold"><widget-label [widget]="this" [fieldName]="'labelAverageRentOverRemainingLeaseTerm'" [align]="'right'"></widget-label></td>
          <td colspan="16"><widget-value [align]="'left'">{{widgetData.averageRentOverRemainingLeaseTerm }}</widget-value></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData.rows?.length + rows?.length + 8" [widget]="this">
        <tr>
          <td colspan="16" class="bold"><widget-label [widget]="this" [fieldName]="'labelProjectedRentForecastYear'" [align]="'right'"></widget-label></td>
          <td colspan="16"><widget-value [align]="'left'">{{widgetData.projectedRent }}</widget-value></td>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="widgetData.rows?.length + rows?.length + 9" [widget]="this">
        <tr class="golden-line-widget-table">
          <td colspan="16" class="bold"><widget-label [widget]="this" [fieldName]="'labelProjectedRentStabilized'" [align]="'right'"></widget-label></td>
          <td colspan="16"><widget-value [align]="'left'">{{widgetData.projectedRentStabilized }}</widget-value></td>
        </tr>
      </dynamic-growth-row>
      <ng-container *ngFor="let row of rows2; let i = index">
        <dynamic-growth-row [row]="widgetData.rows?.length + i + rows?.length + 10" [widget]="this">
          <tr [ngClass]="{ 'lightGreyTableRow': isVisible(i) }">
            <td colspan="8" class="bold"><widget-label [widget]="this" [fieldName]="row.label" [align]="'left'"></widget-label></td>
            <td colspan="2">&nbsp;</td>
            <td colspan="22">
              <widget-value [align]="'right'">
                <ng-container *ngIf="row.type === 'number'">{{ widgetData[row.data] | rdLocalizedNumber:0 }}</ng-container>
                <ng-container *ngIf="row.type === 'date'">{{ widgetData[row.data] | rdLocalizedDate }}</ng-container>
                <ng-container *ngIf="row.type !== 'number' && row.type !== 'date'">{{ widgetData[row.data] }}</ng-container>
                <ng-container *ngIf="row.additionalData == 'unitOfArea'">&nbsp;{{unitOfArea}}</ng-container>
                <ng-container *ngIf="row.additionalData == 'creditRatingSource'">&nbsp;{{widgetData.creditRatingSource}}</ng-container>
              </widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
      </ng-container>
    </tbody>
  </table>
</div>
